
import axios from 'axios';
import { getServerError } from '../error/error-service';
import { IApiComment, IApiCreateCommentData } from './comment-service.types';

const DocApiBaseUrl = `/doc-api`;

export const getCommentList = (documentKey: string) => {
    return axios.get<IApiComment[]>(`${DocApiBaseUrl}/document/${documentKey}/comment`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}


export const createComment = (documentKey: string, data: IApiCreateCommentData) => {
    return axios.post(`${DocApiBaseUrl}/document/${documentKey}/comment`, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const editComment = (commentId: number, data: IApiCreateCommentData) => {
    return axios.put(`${DocApiBaseUrl}/comment/${commentId}`, { ...data })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const deleteComment = (commentId: number) => {
    return axios.delete(`${DocApiBaseUrl}/comment/${commentId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const createCommentList = (documentKeys: string[], data: IApiCreateCommentData) => {
    return axios.post(`${DocApiBaseUrl}/comment`, { ...data, documentKeys })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}
